define([
	"dojo/_base/declare",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"csi/locale",
	"csi/sessionConstants",
	"csi/session",
	"csi/state/rootStore",
	"dojo/text!./Logo.html"
], function(declare, _TemplatedMixin, _WidgetBase, locale, sessionConstants, session, { sessionStore }, template) {

	return declare([_WidgetBase, _TemplatedMixin], {
		baseClass: "csiLogo",
		src: "",
		text: "",
		templateString: template,

		postMixInProperties: function() {
			var params = {};

			if (!sessionConstants.isPortalUser) {
				params[session.LOCATION_TAB] = sessionConstants.isLocalUser ? "SupplierUserHome" : "MyHome";
			}

			this.src = session.getLocationForUrl(sessionStore.homeUrl, params);
			this.text = locale.resource("ThisCompany");
			this.inherited(arguments);
		}
	});
});